import { getCmsApiClientFunctions } from "@kunduz/data-access-cms-api";
import {
  addToCache,
  getFromCache,
  invalidateCache,
} from "@kunduz/utility-node-cache";

export async function getCachedHeaderBanner(lang: string) {
  const _headerBannerCacheInstance = getFromCache(`haaderBanner_${lang}`);
  if (_headerBannerCacheInstance) {
    return _headerBannerCacheInstance._headerBanner;
  } else {
    const cmsClient = getCmsApiClientFunctions();
    const _headerBanner = await cmsClient.getHeaderBanner({
      lang,
    });
    addToCache(`haaderBanner_${lang}`, {
      _headerBanner,
    });

    return _headerBanner;
  }
}

export async function invalidateCachedHeaderBanner() {
  const keys = ["haaderBanner_tr", "haaderBanner_en"];
  invalidateCache(keys);
}
